/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM, color } from 'utils/styles';



// ===================== ANIMATION : QUESTION ===================== //
const aniQuestionResult = {
    // ~~~~~~~~~~~~~~~~~~~~~ RESULT STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .question': {
    	transform: 'translate3d(0%, 0, 0)', // keep on screen to start
        animationName: 'slideOutLeft',
        animationDelay: '.8s',
        animationDuration: '.3s',
        animationFillMode: 'forwards' // needed to maintain FINAL state of animation (otherwise will go back to initial styling = no good)
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniQuestionResult };